import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

import DashMod_Summary02 from './comps/DashMod_Summary02';
import DashMod_Evol01 from './comps/DashMod_Evol01';
// import DashMod_FriendsZone01 from './comps/DashMod_FriendsZone01';


class playerDashboardOptA extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			selectedYearIdx: 0,
			sYears: ['Toutes les années'],

			selectedLeagueIdx: 0,
			playerLeagues: [{
				_id: '0',
				name: "Toutes les ligues"
			}],

			selectedSeasonIdx: 0,
			allPlayerSeasons: [],
			playerSeasons: [{
					_id: '0',
					name: "Toutes les saisons"
			}],
			seasonsLoading: true,
		};
	
		this.dispYearOptions = this.dispYearOptions.bind(this);
		this.dispLeagueOptions = this.dispLeagueOptions.bind(this);
		this.dispSeasonOptions = this.dispSeasonOptions.bind(this);

		this.handleYearChange = this.handleYearChange.bind(this);
		this.handleLeagueChange = this.handleLeagueChange.bind(this);
		this.handleSeasonChange = this.handleSeasonChange.bind(this);
	}

	componentDidMount() {
    // console.log('playerDashboardOptA: componentDidMount');
    if (this.props.playerId) {
      this.loadData(this.props);
    }
	}

  componentDidUpdate(prevProps) {
    if (
      prevProps.playerId !== this.props.playerId ||
      prevProps.resultsType !== this.props.resultsType ||
      prevProps.leagueType !== this.props.leagueType
    ) {
      if (this.props.playerId) {
        this.setState({ seasonsLoading: true });
        this.loadData(this.props);
      }
    }
  }

	loadData(props) {
    if (!props.playerId) return; // NEW guard
	    var _this = this;

		Axios.get('/api/dashmod/summary/seasons/playerId/' + props.playerId + '/resultsType/' + 
			props.resultsType + '/leagueType/' + props.leagueType)
			.then(response => {

				// console.log('playerDashboardOptA: response.data');
				// console.log(response.data);

				var playerLeagues = response.data.leagues;
				var allPlayerSeasons = response.data.seasons;
				var sYears = response.data.seasonYears;

				// Add all leagues/years/seasons
				playerLeagues.unshift({
					_id: '0',
					name: "Toutes les ligues"
				});

				sYears.unshift('Toutes les années')

				var playerSeasons = [...allPlayerSeasons];

				if (playerSeasons.length === 0) {
					playerSeasons.unshift({
						_id: '0',
						name: "Aucune saison"
					});

				}	else {
					playerSeasons.unshift({
						_id: '0',
						name: "Toutes les saisons"
					});
				}

				this.setState({
					selectedLeagueIdx: 0,
					playerLeagues: playerLeagues,
					selectedYearIdx: 0,
					sYears: sYears,
					selectedSeasonIdx: 0,
					allPlayerSeasons: allPlayerSeasons,
					playerSeasons: playerSeasons,
					seasonsLoading: false,
				});
		});	
	}

	render() {
    // console.log('playerDashboardOptA: render');
    if (!this.props.playerId) {
      return null; // NEW: ne rien rendre tant qu’on n’a pas un playerId valide
    }

		var leagueId = this.state.playerLeagues[this.state.selectedLeagueIdx]._id;
		var year = this.state.sYears[this.state.selectedYearIdx];
		var seasonId = this.state.playerSeasons[this.state.selectedSeasonIdx]._id;

		if (year === "Toutes les années") {
			year = "0";
		} else {
			year = year.split("-")[0];
		}

		if (this.state.seasonsLoading) {
			return (
				<div> {this.displaySpinner()} </div>
			)
		} else {

			return (
				<div>
					<div className="row">
					<div className="col-12">
						<strong className="text-uppercase">Informations</strong>
						<ul className="ul-left-aligned">
							<li>Il est maintenant possible de consulter le sommaire de vos statistiques 
								par année, par saison ou par ligue (une année débute au mois d'août)</li>
			    	</ul>
					</div>
					</div>

					<div className="row">
						{this.displayYearSelector()}
						{this.displayLeagueSelector()}
						{this.displaySeasonSelector()}
					</div>
					<hr/>

					<DashMod_Summary02
						year={year} leagueId={leagueId} seasonId={seasonId}	playerId={this.props.playerId} 
						resultsType={this.props.resultsType} leagueType={this.props.leagueType} />

					<DashMod_Evol01 year={year} leagueId={leagueId} seasonId={seasonId} playerId={this.props.playerId} 
						resultsType={this.props.resultsType} leagueType={this.props.leagueType} />

	   		</div>
			)
		}
	}

	displayYearSelector() {
    return (
			<div className="col-md-3">
			<span className="text-uppercase font-weight-bold">Années</span>
				<select className="form-control" 
					value={this.state.selectedYearIdx} onChange={this.handleYearChange}>

					{this.state.sYears.map(this.dispYearOptions)}
      	</select>
			</div>
    );
	}

	displayLeagueSelector() {
    return (
			<div className="col-md-3">
			<span className="text-uppercase font-weight-bold">Ligues</span>
				<select className="form-control" 
					value={this.state.selectedLeagueIdx} onChange={this.handleLeagueChange}>

					{this.state.playerLeagues.map(this.dispLeagueOptions)}
      	</select>
			</div>
    );
	}

	displaySeasonSelector() {

    return (
			<div className="col-md-6">
			<span className="text-uppercase font-weight-bold">Saisons</span>
				<select className="form-control" 
					value={this.state.selectedSeasonIdx} onChange={this.handleSeasonChange}>
					{this.state.playerSeasons.map(this.dispSeasonOptions)}
      	</select>
			</div>
    );
	}
	
	dispYearOptions(sy, syIdx, sYears) {
		return (
			<option value={syIdx} key={'sy'+ syIdx}>{sy}</option>
		)
	}
	dispLeagueOptions(lg, lgIdx, leagues) {
		return (
			<option value={lgIdx} key={'lg.'+ lgIdx}>{lg.name}</option>
		)
	}
	dispSeasonOptions(season, idx, seasons) {
		return (
			<option value={idx} key={'s'+ idx}>{season.name}</option>
		)
	}

	handleLeagueChange(e) {
		var selectedLeagueIdx = parseInt(e.target.value, 10);
		this.setSeasonsList(this.state.selectedYearIdx, selectedLeagueIdx);
	}

	handleYearChange(e) {
		var selectedYearIdx = parseInt(e.target.value, 10);
		this.setSeasonsList(selectedYearIdx, this.state.selectedLeagueIdx);
	}

	setSeasonsList(selectedYearIdx, selectedLeagueIdx) {
		var sYears = this.state.sYears;
		var playerSeasons = [...this.state.allPlayerSeasons];		// initial set
		var playerLeagues = [...this.state.playerLeagues];		// initial set


		// if a year is selected, filter seasons for this selected year
		var allLeaguesTextSuffix = "";
		if (selectedYearIdx !== 0) {

			allLeaguesTextSuffix = " (filtrées)";  // " de " + sYears[selectedYearIdx];
			var seasonStartYear = parseInt(sYears[selectedYearIdx].split('-')[0], 10);
			var seasonStartDate = moment(new Date(seasonStartYear, 7, 15)).format('YYYY-MM-DD');
			var seasonStartDatePlusOneYear = moment(new Date(seasonStartYear+1, 7, 15)).format('YYYY-MM-DD');

			playerSeasons = playerSeasons.filter(ps => (
				// (ps._id !== '-1') && (ps._id !== '0') &&
				moment(ps.dateStart).isSameOrAfter(moment(seasonStartDate)) &&
				moment(ps.dateStart).isBefore(moment(seasonStartDatePlusOneYear))
			));
		}

		// if a year is selected, filter seasons for this selected year
		if (selectedLeagueIdx !== 0) {
			playerSeasons = playerSeasons.filter(ps => (ps.leagueId.toString() === playerLeagues[selectedLeagueIdx]._id.toString()));
		}

		// Add all choices of 'no choice'
		if (playerSeasons.length === 0) {
			playerSeasons.unshift({
				_id: '0',
				name: "Aucune saison"
			});
		} else {
			playerSeasons.unshift({
				_id: '0',
				name: "Toutes les saisons" + allLeaguesTextSuffix
			});			
		}

		sessionStorage.removeItem('statelo-db-evol-dateA');
		sessionStorage.removeItem('statelo-db-evol-dateB');

		this.setState({
			selectedYearIdx: selectedYearIdx,
			selectedLeagueIdx: selectedLeagueIdx,
			selectedSeasonIdx: 0,
			playerSeasons: playerSeasons,
		});

	}

	handleSeasonChange(e) {
		sessionStorage.removeItem('statelo-db-evol-dateA');
		sessionStorage.removeItem('statelo-db-evol-dateB');

		this.setState({
			selectedSeasonIdx: parseInt(e.target.value, 10),
		});
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
  }

}

export default playerDashboardOptA;
